"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeviceSettingEnabled = exports.isCompanyDeviceSettingKey = void 0;
const deviceSettings_1 = require("../models/deviceSettings");
/**
 * Whether a device setting key is company-wide. Narrows the key, so callers can check any
 * `DeviceSettingMetaKeys` value and then index `COMPANY_DEVICE_SETTING_DEFAULTS` with it.
 */
const isCompanyDeviceSettingKey = (key) => deviceSettings_1.COMPANY_DEVICE_SETTING_KEYS.some((companyKey) => companyKey === key);
exports.isCompanyDeviceSettingKey = isCompanyDeviceSettingKey;
/**
 * Resolves a boolean company-wide setting, falling back to its default when the setting is
 * missing or has no value. Only the string 'true' counts as enabled.
 */
const isDeviceSettingEnabled = (settings, key) => {
    var _a;
    const storedValue = (_a = settings.find((setting) => setting.metaKey === key)) === null || _a === void 0 ? void 0 : _a.metaValue;
    const value = storedValue !== null && storedValue !== void 0 ? storedValue : deviceSettings_1.COMPANY_DEVICE_SETTING_DEFAULTS[key].metaValue;
    return value === 'true';
};
exports.isDeviceSettingEnabled = isDeviceSettingEnabled;
//# sourceMappingURL=deviceSettings.js.map